import React from "react";

export const Close = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      transform="rotate(45)"
    >
      <path
        d="M11.5652 21.5652C11.5652 21.8057 11.76 22 12 22C12.24 22 12.4348 21.8057 12.4348 21.5652V12.4348H21.5652C21.8057 12.4348 22 12.24 22 12C22 11.76 21.8057 11.5652 21.5652 11.5652H12.4348V2.43478C12.4348 2.19478 12.24 2 12 2C11.76 2 11.5652 2.19478 11.5652 2.43478V11.5652H2.43478C2.19478 11.5652 2 11.76 2 12C2 12.24 2.19478 12.4348 2.43478 12.4348H11.5652V21.5652Z"
        fill="#414042"
      />
    </svg>
  );
};
